import { render, staticRenderFns } from "./LogLeilao.vue?vue&type=template&id=6b782e74"
import script from "./LogLeilao.vue?vue&type=script&lang=js"
export * from "./LogLeilao.vue?vue&type=script&lang=js"
import style0 from "./LogLeilao.vue?vue&type=style&index=0&id=6b782e74&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports